import styled from 'styled-components';
import { Checkbox } from 'ui/checkboxV2';
import { ModalBody } from 'ui/modal';
import { PopoverContent, PopoverTrigger } from 'ui/popover';
import { spacing, subtitle2 } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const StyledModalBody = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const StyledModalBodyPlusHalf = styled(ModalBody)`
  display: flex;
  flex-direction: column;
  gap: ${spacing.plusHalf};
`;

export const StyledInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.half};
`;

export const StyledInputLabel = styled.div`
  ${subtitle2}
`;

export const StyledCheckbox = styled(Checkbox)`
  align-items: flex-start;
`;

export const StyledList = styled.ul`
  list-style-type: disc;
  margin-bottom: 0;
  padding-left: ${pxToRem(18)};
`;

export const StyledPopoverTrigger = styled(PopoverTrigger)`
  display: inline-flex;
  position: relative;
  top: ${pxToRem(-2)};
`;

export const StyledPopoverContent = styled(PopoverContent)`
  max-width: ${pxToRem(250)};
`;

export const StyledFlexSection = styled.section`
  align-items: flex-start;
  display: inline-flex;
`;

export const StyledBodySection = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const StyledDescList = styled.dl`
  column-gap: ${spacing.x3};
  display: grid;
  grid-template-columns: ${pxToRem(140)} 1fr;
  margin-bottom: 0;
  row-gap: ${spacing.base};
`;
